/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    DriverChangesHeader: {
        id: 'cep.components.sgEndorsementQuotePage.DriverChangesHeader',
        defaultMessage: 'Driver Changes'
    },
    DriverAdded: {
        id: 'cep.components.sgEndorsementQuotePage.DriverAdded',
        defaultMessage: 'Driver added: {driver}'
    },
    AlternativeAddress: {
        id: 'cep.components.sgEndorsementQuotePage.AlternativeAddress',
        defaultMessage: 'Is the vehicle going to be kept at an alternative address? If it is, please call us on {phoneNumber} to ensure you are fully covered'
    },
    DriverRemoved: {
        id: 'cep.components.sgEndorsementQuotePage.DriverRemoved',
        defaultMessage: 'Removed driver: {driver}'
    },
    MileageChange: {
        id: 'cep.components.sgEndorsementQuotePage.DriverChanges.MileageChange',
        defaultMessage: 'Change mileage to: {mileage}'
    },
    VehicleUseChange: {
        id: 'cep.components.sgEndorsementQuotePage.DriverChanges.VehicleUseChange',
        defaultMessage: 'Changed use of car to: {use}'
    }
});
